import React from "react";
import { Trash2, Eye, EyeOff, ScanSearch } from "lucide-react";
import OrderedIconActionContextRow from "../../ui/OrderedIconActionContextRow";
import { ReparentMenuIcon } from "./icons";
import SceneGraphReparentBodyList from "./SceneGraphReparentBodyList";

export default function SceneGraphSiteContextMenu({
  contextMenuSiteIds,
  reparentSubmenuOpen,
  setReparentOnlySubmenuKey,
  closeContextSubmenus,
  setContextMenuOpen,
  isPhysicsRunning,
  worldRootTargetBodyUuid,
  groupedMeshParentOptions,
  bodies,
  viewerActions,
  siteVisibility,
  inspectContextMenuTarget,
  handleDeleteSites,
  handleMoveSitesToBody,
}) {
  return (
    <>
      <div className="px-2 py-1.5 text-[11px] font-semibold text-gray-400 uppercase tracking-wide">
        {contextMenuSiteIds.length} {contextMenuSiteIds.length === 1 ? "site" : "sites"} selected
      </div>
      <div className="px-2 pb-1.5">
        <OrderedIconActionContextRow
          activeSubmenuKey={reparentSubmenuOpen ? "reparent" : null}
          setActiveSubmenuKey={setReparentOnlySubmenuKey}
          submenuClassName="mt-1 min-w-[180px] rounded-md border border-gray-600 p-0.5 shadow-xl"
          submenuStyle={{ backgroundColor: "rgba(40, 40, 40, 0.95)" }}
          actions={[
            {
              key: "inspect",
              label: "Inspect",
              icon: <ScanSearch className="w-4 h-4" aria-hidden="true" />,
              onDefaultClick: inspectContextMenuTarget,
            },
            (() => {
              const allSiteVisible = contextMenuSiteIds.every((id) => siteVisibility[id] !== false);
              return {
                key: "visibility",
                label: allSiteVisible ? "Hide" : "Show",
                icon: allSiteVisible ? (
                  <EyeOff className="w-4 h-4" aria-hidden="true" />
                ) : (
                  <Eye className="w-4 h-4" aria-hidden="true" />
                ),
                disabled: isPhysicsRunning,
                disabledByPhysics: isPhysicsRunning,
                onDefaultClick: () => {
                  if (isPhysicsRunning) return;
                  contextMenuSiteIds.forEach((id) =>
                    viewerActions.setSiteVisibility(id, !allSiteVisible)
                  );
                  setContextMenuOpen(false);
                },
              };
            })(),
            {
              key: "delete",
              label: "Delete",
              icon: <Trash2 className="w-4 h-4" aria-hidden="true" />,
              disabled: isPhysicsRunning,
              disabledByPhysics: isPhysicsRunning,
              onHover: closeContextSubmenus,
              onClick: () => handleDeleteSites(contextMenuSiteIds),
            },
            {
              key: "reparent",
              label: "Reparent",
              icon: <ReparentMenuIcon />,
              disabled: isPhysicsRunning || contextMenuSiteIds.length === 0,
              disabledByPhysics: isPhysicsRunning,
              onDefaultClick: () => {
                if (isPhysicsRunning || contextMenuSiteIds.length === 0 || !worldRootTargetBodyUuid)
                  return;
                handleMoveSitesToBody(worldRootTargetBodyUuid);
              },
              submenu: (
                <SceneGraphReparentBodyList
                  groupedParentOptions={groupedMeshParentOptions}
                  bodies={bodies}
                  onSelectBody={handleMoveSitesToBody}
                />
              ),
            },
          ]}
        />
      </div>
    </>
  );
}
